export default __webpack_public_path__ + "static/media/num_4.df6486ce.svg";